// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wfXb","col":"styles_col__1Zkyk"};